export default __webpack_public_path__ + "static/media/arrow-right.107c6975.svg";